import { useGetObjectPropertiesQuery } from '../../../services/mapping/bacnet/bacnetStateApi'
import { LoadingView } from '../../../components/LoadingView'
import { Block } from 'baseui/block';
import { BacnetObjectTypes, BacnetPropertyIds, BacnetObjectPropertyState, useWriteBacnetValueMutation, WriteBacnetValueCommand } from '../../../services/mapping/bacnet';
import { useStyletron } from 'baseui';
import { ListItemLabel, ListItem, } from 'baseui/list';
import { LabelLarge, ParagraphSmall, ParagraphXSmall } from 'baseui/typography';
import TimeAgo from 'react-timeago'
import { IoCalendarOutline } from 'react-icons/io5';
import { VscEdit } from 'react-icons/vsc';
import { Button } from 'baseui/button';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import { useEffect, useState } from 'react';
import { Input } from "baseui/input";
import { FormControl } from 'baseui/form-control';
import { useReportMutationState } from '../../../hooks/useReportMutationState';

export type BacnetObjectPropertiesProps = {
    edgeDeviceId: string,
    deviceId: number,
    instanceId: number,
    objectType: BacnetObjectTypes
}

const BacnetObjectProperties = (props: BacnetObjectPropertiesProps) => {

    const [css] = useStyletron();
    const { data, error, isLoading, isSuccess, currentData } = useGetObjectPropertiesQuery({ edgeDeviceId: props.edgeDeviceId, deviceId: props.deviceId, instanceId: props.instanceId, objectType: props.objectType });
    const items = data;
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState<any>();

    return (
        <Block>
            <LabelLarge>{BacnetObjectTypes[props.objectType]} [{props.instanceId}]</LabelLarge>
            <ParagraphSmall>Properties</ParagraphSmall>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <ul
                    className={css({
                        paddingLeft: 0,
                        paddingRight: 0,
                    })}
                >
                    {items?.map((item: BacnetObjectPropertyState, index: number) => (
                        <ListItem key={item.id} endEnhancer={() => (
                            <>{(!isReadOnly(item.propertyType)) && <Button onClick={() => { setSelectedItem(item); setIsOpen(true) }} kind='tertiary' shape='circle'><VscEdit></VscEdit></Button>}</>
                        )}>
                            <ListItemLabel description={<Description {...item}></Description>}>
                                <Header {...item}></Header>
                            </ListItemLabel>
                        </ListItem>
                    ))}
                </ul>
                <EditValueDialog isOpen={isOpen} onClose={() => setIsOpen(false)} item={selectedItem} {...props}></EditValueDialog>
            </LoadingView>
        </Block>
    )
}

export default BacnetObjectProperties;

const Description = (props: BacnetObjectPropertyState) => {
    const [css,theme] = useStyletron();
    return (
        <>
            <div title={JSON.stringify(props.value.value)} className={css({
                maxWidth: "600px",
                textOverflow: "ellipsis",
                overflow: "hidden"
            })}>{props.value.value?.toString() || 'NULL'}</div>

            <ParagraphXSmall color={theme.colors.contentTertiary} margin={0} title={props.value.properties.tSource}><IoCalendarOutline></IoCalendarOutline> <TimeAgo date={props.value.properties.tSource}></TimeAgo></ParagraphXSmall>
            {props.value.properties.error && <span>ERROR: {props.value.properties.error}</span>}
        </>
    );
}
const Header = (props: BacnetObjectPropertyState) => {
    const name = BacnetPropertyIds[props.propertyType] || `${props.propertyType} (proprietary)`;
    return (
        <>
            {name}
        </>
    );
}


const EditValueDialog = (props: {
    isOpen,
    onClose,
    deviceId: number,
    objectType: BacnetObjectTypes,
    instanceId: number,
    edgeDeviceId,
    item: BacnetObjectPropertyState
}) => {

    const [write, writeResult] = useWriteBacnetValueMutation();
    useReportMutationState(writeResult, props.onClose);
    const [value, setValue] = useState(props.item?.value?.value)
    const handleOk = () => {
        var cmd: WriteBacnetValueCommand = {
            deviceId: props.deviceId,
            edgeDeviceId: props.edgeDeviceId,
            objectId: props.instanceId,
            objectType: props.objectType,
            propertyId: props.item.propertyType,
            value: value
        }
        write(cmd);
    }

    useEffect(() => {
        setValue(props.item?.value?.value);
    }, [props.item])

    return (
        <>
            {props.isOpen &&
                <Modal isOpen={props.isOpen} onClose={props.onClose}>
                    <ModalHeader>Edit Value</ModalHeader>
                    <ModalBody>
                        <FormControl
                            label={() => BacnetPropertyIds[props.item.propertyType]}
                            caption={() => "Enter a new value"}
                        >
                            <Input value={value} onChange={(e) => setValue(e.target.value)}></Input>
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <ModalButton kind='tertiary' onClick={props.onClose}>Cancel</ModalButton>
                        <ModalButton onClick={handleOk} isLoading={writeResult.isLoading} >Okay</ModalButton>
                    </ModalFooter>
                </Modal>}
        </>
    );
}

const isReadOnly = (prop: BacnetPropertyIds) => {
    switch (prop) {
        case BacnetPropertyIds.DESCRIPTION:
        case BacnetPropertyIds.MAX_PRES_VALUE:
        case BacnetPropertyIds.MIN_PRES_VALUE:
        case BacnetPropertyIds.UNITS:
        case BacnetPropertyIds.COV_INCREMENT:
        case BacnetPropertyIds.DEADBAND:
        case BacnetPropertyIds.LOW_LIMIT:
        case BacnetPropertyIds.HIGH_LIMIT:
        case BacnetPropertyIds.LIMIT_ENABLE:
        case BacnetPropertyIds.OBJECT_NAME:
        case BacnetPropertyIds.RELINQUISH_DEFAULT:
        case BacnetPropertyIds.POLARITY:
        case BacnetPropertyIds.SCALE_FACTOR:
        case BacnetPropertyIds.ADJUST_VALUE:
            return false;

        default:
            return true;
    }
}